import { useSearchParams } from "react-router-dom";

export default function useCustomParams() {
  const [searchParams] = useSearchParams();

  // Convertit automatiquement les params en objet JS
  const paramsObject: Record<string, string> = {};

  searchParams.forEach((value, key) => {
    paramsObject[key] = value;
  });

  return paramsObject;
}
